

/** @type {import('./uri')} */
module.exports = URIError;




//////////////////
// WEBPACK FOOTER
// ../node_modules/es-errors/uri.js
// module id = ../node_modules/es-errors/uri.js
// module chunks = 1